import * as React from "react";
import { CircularProgress, Grid } from "@material-ui/core";
export function LoadingSpinner() {
    return (React.createElement(Grid, { container: true, style: { height: "100%", color: '#BF0D3E', backgroundColor: 'transparent' }, alignItems: "center" },
        React.createElement(CircularProgress, { style: { margin: "auto" } })));
}
